// src/components/ui/Button.js
import React from 'react';

const Button = ({ 
  children, 
  variant = 'primary', 
  icon, 
  onClick, 
  href, 
  className = '',
  size = 'medium'
}) => {
  const variants = {
    primary: 'bg-primary text-white hover:bg-primary-dark border-2 border-primary hover:border-primary-dark',
    secondary: 'bg-transparent border-2 border-primary text-primary hover:bg-primary hover:text-white',
    outline: 'bg-transparent border-2 border-brown/20 text-brown hover:border-primary hover:text-primary',
    light: 'bg-cream-dark text-primary hover:bg-cream border-2 border-transparent',
  };

  const sizes = {
    small: 'px-4 py-2 text-sm',
    medium: 'px-6 py-3 text-base',
    large: 'px-8 py-4 text-lg',
  };

  const baseClasses = `${sizes[size]} rounded-full font-medium transition-all duration-300 inline-flex items-center gap-2 justify-center`;

  const combinedClasses = `${baseClasses} ${variants[variant]} ${className}`;

  if (href) {
    return (
      <a href={href} className={combinedClasses}>
        {children}
        {icon && <span className="text-lg">{icon}</span>}
      </a>
    );
  }

  return (
    <button onClick={onClick} className={combinedClasses}>
      {children}
      {icon && <span className="text-lg">{icon}</span>}
    </button>
  );
};

export default Button;

// Usage Examples:
// <Button variant="primary">Contact Us</Button>
// <Button variant="secondary" icon="→">View Services</Button>
// <Button variant="outline" size="small">Learn More</Button>